if (window.location.pathname == '/contact/thank-you') {
  localStorage.removeItem('orderItems');
}
